import { Link } from 'react-router-dom';
import { heroBanner, mangas } from '@/mocks/manga';

export default function Hero() {
  const totalViews = mangas.reduce((sum, m) => sum + m.views, 0);
  const totalChapters = mangas.reduce((sum, m) => sum + m.totalChapters, 0);

  return (
    <section className="relative flex h-[540px] w-full items-center justify-center overflow-hidden md:h-[620px]">
      <img
        src={heroBanner}
        alt="健身教练漫画免费阅读横幅推荐"
        title="健身教练漫画免费阅读"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/45 to-foreground-950/75" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 pt-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur md:text-sm">
          <i className="ri-fire-fill text-secondary-300" aria-hidden="true" />
          热门连载 · 免费阅读 · 每日更新
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-snug text-background-50 md:text-5xl">
          073漫画网 · 《健身教练》漫画
          <span className="mt-2 block font-heading text-xl text-background-50/90 md:text-2xl">
            免费下拉式阅读，滑动屏幕即可感受力量与汗水的故事
          </span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-50/80 md:text-base">
          热血健身漫画《健身教练》在073漫画网可免费下拉式阅读。主人公陈野在王牌教练铁哥的带领下突破极限、重塑自我，燃点密集、干货十足。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/manga/m1"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 shadow-none transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-fill" aria-hidden="true" />
            立即阅读《健身教练》
          </Link>
          <Link
            to="/category"
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            浏览全部漫画
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <dl className="mx-auto mt-10 grid max-w-lg grid-cols-3 gap-4">
          <div className="rounded-lg border border-background-50/15 bg-background-50/10 px-3 py-3 backdrop-blur">
            <dd className="font-heading text-lg text-background-50 md:text-2xl">10+</dd>
            <dt className="mt-1 text-xs text-background-50/75">连载作品</dt>
          </div>
          <div className="rounded-lg border border-background-50/15 bg-background-50/10 px-3 py-3 backdrop-blur">
            <dd className="font-heading text-lg text-background-50 md:text-2xl">{(totalChapters / 1000).toFixed(1)}千+</dd>
            <dt className="mt-1 text-xs text-background-50/75">章节内容</dt>
          </div>
          <div className="rounded-lg border border-background-50/15 bg-background-50/10 px-3 py-3 backdrop-blur">
            <dd className="font-heading text-lg text-background-50 md:text-2xl">{(totalViews / 10000000).toFixed(1)}千万+</dd>
            <dt className="mt-1 text-xs text-background-50/75">总阅读量</dt>
          </div>
        </dl>
      </div>
    </section>
  );
}